module.exports = __webpack_public_path__ + "public/img/gdxw.7e86a013.png";